
















































































































import Toolbar from '@/components/Toolbar.vue';
import ReportError from '@/reports/ReportError.vue';
import { State } from '@/store/State';
import { Client } from '@holistic/shared/src/domain/Client';
import Vue from 'vue';
import { Component, Inject } from 'vue-property-decorator';
import { ReportFileService } from './ReportFileService';

@Component({
  components: {
    Toolbar,
    ReportError,
  },
})
export default class Reports extends Vue {
  public $refs!: {
    form: HTMLFormElement;
  };
  @Inject('reportFileService')
  private reportFileService!: ReportFileService;

  private loading = true;
  private displayDialog = false;
  private file: File | null = null;
  private uploading = false;
  private clientId = '';
  private clientRules = [
    (client: Client | null) => !!client || 'Client Required',
  ];

  private async created() {
    await this.$store.dispatch('bindReports');
    await this.$store.dispatch('bindClients');
    await this.$store.dispatch('bindReportErrors');
    this.loading = false;
  }

  private async addReport() {
    if (!this.$refs.form.validate()) {
      return;
    }
    this.uploading = true;
    await this.reportFileService.upload(this.file, this.clientId);
    this.displayDialog = false;
    this.uploading = false;
    this.file = null;
  }

  private destroyed() {
    this.$store.dispatch('unbindReports');
    this.$store.dispatch('unbindClients');
    this.$store.dispatch('unbindReportErrors');
  }

  private get clients() {
    return (this.$store.state as State).clients;
  }

  private get reports() {
    return (this.$store.state as State).reports;
  }

  private get reportErrors() {
    return (this.$store.state as State).reportErrors;
  }

  private get showEmptyMessage() {
    return !this.loading && this.reports.length === 0;
  }

  private createReportLink(id: string) {
    return `/report-test.html?id=${id}`;
  }

  private createWidgetLink(id: string) {
    return `/widget-test.html?id=${id}`;
  }

  private createEmbeddableCodeReport(id: string) {
    return `
     <div id="holistic-report-container" data-holistic-report-id="${id}"></div>
     <script src="https://${location.host}/js/report.js"><\/script>`;
  }
  private createEmbeddableCodeWidget(id: string) {
    return `
     <div id="holistic-widget-container" data-holistic-widget-id="${id}"></div>
     <script src="https://${location.host}/js/widget.js"><\/script>`;
  }

  private toggleDialog() {
    this.displayDialog = !this.displayDialog;
  }
}
